import TasksAssignedStore from './TasksAssignedStore'
import TasksCreatedStore from './TasksCreatedStore'
import TasksPersonalStore from './TasksPersonalStore'

export default { TasksAssignedStore, TasksCreatedStore, TasksPersonalStore }
